<template>
    <div
        class="expiryNotification"
        :class="popUpState ? 'fade-out' : 'fade-in'"
        v-show="visible"
    >
        <div class="renew" @click="openPopup()">
            <span>RENEW TRAQADE</span>
        </div>
        <div class="content">
            <div style="display: flex; justify-content: space-between;">
                <p class="title">Alert! Your subscription is expiring soon</p>
                <div class="close-icon" @click="closePopup()">
                    <icon-base height="24" width="24">
                        <icon-close></icon-close>
                    </icon-base>
                </div>
            </div>
            <p class="caption">
                Your subscription for Traqade is expiring soon. To continue
                managing your fitness studio better renew your subscription by
                calling 011-41187544 today!
            </p>
        </div>
    </div>
</template>
<script>
function checkUserClosedPopupBefore() {
    return window.localStorage.getItem("@traqade-expiry-popup") === "1";
}

function userClosedThePopup() {
    window.localStorage.setItem("@traqade-expiry-popup", "1");
}
function userOpenedThePopup() {
    window.localStorage.setItem("@traqade-expiry-popup", "0");
}

import IconClose from "../components/icon/navigation/IconClose";
import IconBase from "../components/icon/IconBase.vue";
export default {
    name: "ExpiryNotification",
    data() {
        return {
            popUpState: checkUserClosedPopupBefore(),
            visible: window.isAccountExpiringIn7Days,
        };
    },
    components: {
        IconBase,
        IconClose,
    },
    methods: {
        closePopup: function() {
            this.popUpState = true;
            userClosedThePopup();
        },
        openPopup: function() {
            this.popUpState = false;
            userOpenedThePopup();
        },
    },
};
</script>
<style lang="scss">
.expiryNotification {
    position: fixed;
    bottom: 130px;
    right: 0;
    height: 158px;
    width: 480px;
    display: flex;
    align-items: center;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    box-shadow: 0 2px 6px 0 rgba(62, 63, 66, 0.5);
    background-color: #ffffff;
    transition: all 0.2s ease;
    z-index: 1000;
    &.fade-out {
        right: -440px !important;
    }
    .renew {
        background-image: linear-gradient(to top, #eb5757, #eb8357);
        height: 40px;
        width: 158px;
        padding: 6px;
        text-transform: uppercase;
        position: absolute;
        bottom: -40px;
        transform-origin: 0 0;
        transform: rotate(-90deg);
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: white;
        text-align: center;
        font-weight: 600;
        letter-spacing: 0.5px;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .content {
        padding: 24px 24px 24px 64px;
        .close-icon {
            cursor: pointer;
        }
        .title {
            font-size: 20px;
            letter-spacing: 0.1px;
            font-weight: 600;
            margin-bottom: 16px;
        }
        .caption {
            font-size: 16px;
            letter-spacing: 0.1px;
            color: rgba(62, 63, 66, 0.75);
            margin: 0;
            padding-right: 20px;
        }
    }
}
</style>
